<script setup lang="ts">
import { AuthRegisterForm } from '../../auth/components';
definePageMeta({
  layout: 'guest',
  auth: {
    unauthenticatedOnly: true,
    navigateAuthenticatedTo: '/',
  },
});

useHead({
  title: 'Register',
});
</script>
<template>
  <v-container class="d-flex mt-5xl">
    <AuthRegisterForm data-testid="register-form" />
  </v-container>
</template>
<style lang="scss" scoped>
.v-form {
  width: 100%;
  max-width: 486px;
  position: relative;
  margin: auto;
}
</style>
